import instance from 'api';
import _ from 'lodash';
import produce from 'immer';
import { normalize, schema } from 'normalizr';

import coinDescriptionsJson from 'assets/coin-descriptions.json';

export const CURRENCY_DATA = {
  STARTED: 'CURRENCY_DATA_STARTED',
  SUCCESS: 'CURRENCY_DATA_SUCCESS',
  FAIL: 'CURRENCY_DATA_FAIL',
};

const currencySchema = new schema.Entity('currencies', {}, { idAttribute: 'symbol' });

const normalizedCoinDescriptions = normalize(coinDescriptionsJson, [currencySchema]);

export const getCurrencyData = () => async (dispatch) => {
  dispatch({ type: CURRENCY_DATA.STARTED });

  try {
    const { data } = await instance({
      url: '/api/get_coin_stats',
      method: 'GET',
    });

    if (data.status === 'Success') {
      const marketCapData = data.data;

      const updatedCurrencyData = produce(marketCapData, (draft) => {
        Object.entries(draft).forEach(([key, currency]) => {
          _.set(draft, `${key}.symbol`, currency.symbol.toUpperCase());

          const additionalData = _.get(normalizedCoinDescriptions, `entities.currencies.${currency.symbol.toUpperCase()}`);

          if (additionalData) {
            draft[key].additionalData = additionalData;
          }
        });
      });

      dispatch({
        type: CURRENCY_DATA.SUCCESS,
        payload: updatedCurrencyData,
      });
    }
  } catch (error) {
    console.error('Error fetching currency data:', error);
    dispatch({ type: CURRENCY_DATA.FAIL });
  }
};

export const updateCurrencyData = (data) => {
  if (data.status === 'Success') {
    const marketCapData = data.data;

    const updatedCurrencyData = produce(marketCapData, (draft) => {
      Object.entries(draft).forEach(([key, currency]) => {
        const symbol = currency?.exchangeTicker?.toUpperCase();
        _.set(draft, `${key}.symbol`, symbol);

        const additionalData = _.get(normalizedCoinDescriptions, `entities.currencies.${symbol}`);

        if (additionalData) {
          draft[key].additionalData = additionalData;
        }
      });
    });

    return {
      type: CURRENCY_DATA.SUCCESS,
      payload: updatedCurrencyData,
    };
  }

  return { type: CURRENCY_DATA.FAIL };
};
